/**
 * CORE-1612 — сколько ждать до следующего сообщения в чате: не больше `burst`
 * сообщений за любые `windowMs`. Тот же счёт, что у сервера (ChatSendBudget в
 * бэкенде): клиент, который пускает чаще сервера, снова терял бы второе
 * сообщение, а который строже — блокировал бы обычную переписку.
 *
 * `sent` — времена отправленных сообщений, по возрастанию; устаревшие
 * выбрасываются на месте. Возвращает 0, если отправлять можно сейчас.
 */
export function chatSendWaitMs(sent: number[], now: number, burst: number, windowMs: number): number {
  while (sent.length > 0 && now - sent[0] >= windowMs) sent.shift();
  if (sent.length < burst) return 0;
  return sent[sent.length - burst] + windowMs - now;
}
